import React from 'react';
import {SvgIconComponent} from '../types';

// SVG Source copied from Figma
export const ColoredGoogleLogo: SvgIconComponent = props => (
  // use `svg` instead of `SvgIcon` so the fill color isn't overridden by the theme
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21.81 10.04H21V10H12V14H17.65C16.83 16.33 14.61 18 12 18C8.69 18 6 15.31 6 12C6 8.69 8.69 6 12 6C13.53 6 14.92 6.58 15.98 7.52L18.81 4.69C17.02 3.03 14.63 2 12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 11.33 21.93 10.68 21.81 10.04Z"
      fill={props.fill || '#FFC107'}
    />
    {!props.fill && (
      <>
        <path
          d="M3.15039 7.35L6.44039 9.76C7.33039 7.55 9.48039 6 12.0004 6C13.5304 6 14.9204 6.58 15.9804 7.52L18.8104 4.69C17.0204 3.03 14.6304 2 12.0004 2C8.16039 2 4.83039 4.17 3.15039 7.35Z"
          fill="#FF3D00"
        />
        <path
          d="M11.9996 22C14.5796 22 16.9296 21.01 18.6996 19.4L15.5996 16.78C14.6096 17.55 13.3596 18 11.9996 18C9.39961 18 7.18961 16.34 6.35961 14.03L3.09961 16.54C4.74961 19.78 8.10961 22 11.9996 22Z"
          fill="#4CAF50"
        />
        <path
          d="M21.81 10.04H21V10H12V14H17.65C17.25 15.12 16.53 16.08 15.61 16.79L18.7 19.41C18.49 19.6 22 17 22 12C22 11.33 21.93 10.68 21.81 10.04Z"
          fill="#1976D2"
        />
      </>
    )}
  </svg>
);
